import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth.module';
import breadcrumbs from './modules/breadcrumbs.module';
import config from './modules/config.module';
import htmlClass from './modules/htmlclass.module';
import images from './modules/image.module';
import installmentCategory from './modules/installmentCategory.module';
import menu from './modules/menu.module';
import permission from './modules/permission.module';
import permissionMatrix from './modules/permissionMatrix.module';
import product from './modules/product.module';
import transactionCategory from './modules/transactionCategory.module';
import stores from './modules/store/store-info.module';
import orderCustomerInfo from './modules/order/order-customer-info.module';
import orderInfo from './modules/order/order-info.module';
import orderDiscount from './modules/order/order-discount.module';
import orderNote from './modules/order/order-note.module';
import orderProducts from './modules/order/order-product-table.module';
import orderSeletedStatus from './modules/order/order-seleted-status.module';
import paymentIntallment from './modules/payment/payment-installment.module';
import selectedBillWarranty from './modules/warranty-bill/selected-bill-warranty.module';
import einvoice from './modules/einvoice/einvoice.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    menu,
    product,
    images,
    permission,
    permissionMatrix,
    transactionCategory,
    stores,
    installmentCategory,
    orderCustomerInfo,
    orderInfo,
    orderDiscount,
    orderNote,
    orderProducts,
    orderSeletedStatus,
    paymentIntallment,
    selectedBillWarranty,
    einvoice,
  },
});
